module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.26.0@babel-runtime/core-js/get-iterator.js
// module id = 190
// module chunks = 3